export default "__VITE_ASSET__BfwrYBMK__"